<template>
    <div v-if="shouldShow" class="flex flex-col gap-1">
        <general-input
            v-model="invoiceNo"
            placeholder="Fakturanr."
        />
    </div>
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import GeneralInput from '@/components/GeneralInput.vue'
import {computed, onUnmounted, watch} from 'vue'
import {watchDebounced} from '@vueuse/core'
import {checkDuplicateInvoiceNo} from '@/transaction/transaction.service'
import {duplicateInvoiceLineUuids} from '@/transaction/create-transaction/duplicateInvoiceWarnings'

const line = defineModel<TransactionEntryLine>({required: true})

const shouldShow = computed(() => {
    return line.value.creditSubAccount || line.value.debitSubAccount
})

const subAccountUuid = computed(() => line.value.creditSubAccount || line.value.debitSubAccount)

const setDuplicate = (isDup: boolean) => {
    const uuid = line.value.entryUuid
    if (isDup) {
        if (!duplicateInvoiceLineUuids.value.includes(uuid)) {
            duplicateInvoiceLineUuids.value = [...duplicateInvoiceLineUuids.value, uuid]
        }
    } else {
        duplicateInvoiceLineUuids.value = duplicateInvoiceLineUuids.value.filter(u => u !== uuid)
    }
}

const invoiceNo = computed({
    get: () => line.value.invoiceNo,
    set: (newInvoiceNo: string) => {
        if (newInvoiceNo === '') {
            line.value.invoiceDueDate = undefined
            line.value.invoiceNo = undefined
            setDuplicate(false)
        } else if (line.value.invoiceNo !== newInvoiceNo) {
            line.value.invoiceUuid = undefined
            if (!line.value.invoiceDueDate) {
                const dueDate = new Date(line.value.date)
                dueDate.setDate(dueDate.getDate() + 14)
                line.value.invoiceDueDate = dueDate
            }
            line.value.invoiceNo = newInvoiceNo
        }
    }
})

const runDuplicateCheck = async () => {
    const no = line.value.invoiceNo
    const sacc = subAccountUuid.value
    if (!no || !sacc) {
        setDuplicate(false)
        return
    }
    setDuplicate(await checkDuplicateInvoiceNo(no, sacc))
}

watchDebounced([() => line.value.invoiceNo, subAccountUuid], runDuplicateCheck, {debounce: 400})
watch(shouldShow, (v) => { if (!v) setDuplicate(false) })
onUnmounted(() => setDuplicate(false))
</script>
